import { render, staticRenderFns } from "./NewCheckBox.vue?vue&type=template&id=114fc19c&scoped=true"
import script from "./NewCheckBox.vue?vue&type=script&lang=js"
export * from "./NewCheckBox.vue?vue&type=script&lang=js"
import style0 from "./NewCheckBox.vue?vue&type=style&index=0&id=114fc19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fc19c",
  null
  
)

export default component.exports